jQuery(function ($) {


    $('[js-more-news]').click(function () {

        $.ajax({
            url: news_loadmore_params.ajaxurl, // AJAX handler
            data: {
                'action': 'loadmorebutton', // the parameter for admin-ajax.php
                'query': news_loadmore_params.posts, // loop parameters passed by wp_localize_script()
                'page': news_loadmore_params.current_page // current page
            },
            type: 'POST',
            beforeSend: function (xhr) {
                $('[js-more-news]').text(news_loadmore_params.loading_text); // some type of preloader

            },
            success: function (posts) {
                if (posts) {

                    $('[js-more-news]').text(news_loadmore_params.btn_text);
                    $('[js-news-results]').append(posts); // insert new posts
                    news_loadmore_params.current_page++;


                    if (news_loadmore_params.current_page == news_loadmore_params.max_page)
                        $('[js-more-news]').hide(); // if last page, HIDE the button

                } else {
                    $('[js-more-news]').hide(); // if no data, HIDE the button as well
                }
            }
        });
        return false;
    });


    $('[js-news-form]').change(function () {
        var filter = $('[js-news-form]');
        $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
            beforeSend: function (xhr) {
                $('[js-more-news]').hide();
                $('[js-news-results]').html('<div class="loading-wrapper"><div class="loading"></div></div>');
            },
            success: function (data) {
                // console.log(data)
                let parsedData = JSON.parse(data);
                // when filter applied:
                // set the current page to 1
                news_loadmore_params.current_page = 1;

                // set the new query parameters
                news_loadmore_params.posts = parsedData.posts;

                // set the new max page parameter
                news_loadmore_params.max_page = parsedData.max_page;

                $('[js-news-results]').html(parsedData.content); // insert data

                if (parsedData.max_page < 2) {
                    $('[js-more-news]').hide();
                } else {
                    $('[js-more-news]').show();
                }
            }
        });
        return false;
    });
});

